var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoPilot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1470_761)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 64,
    height: 64,
    rx: 12,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 62,
    height: 62,
    rx: 11,
    stroke: "#373737",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4519 21.1041C44.9695 19.4615 43.4622 18.3333 41.7502 18.3333H40.624C38.7618 18.3333 37.1654 19.6633 36.8293 21.4949L34.9004 32.0059L35.3791 30.3682C35.8599 28.7232 37.3682 27.5925 39.0821 27.5925H45.627L48.3718 28.6618L51.0177 27.5925H50.2455C48.5334 27.5925 47.0262 26.4643 46.5437 24.8217L45.4519 21.1041Z",
    fill: "url(#paint0_radial_1470_761)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9422 48.8799C29.4193 50.5304 30.9304 51.6665 32.6486 51.6665H35.0405C37.1327 51.6665 38.8435 49.999 38.8972 47.9076L39.1578 37.7725L38.6128 39.6334C38.1314 41.2775 36.6234 42.4073 34.9102 42.4073H28.311L25.9582 41.131L23.4111 42.4073H24.1705C25.8886 42.4073 27.3997 43.5434 27.8767 45.194L28.9422 48.8799Z",
    fill: "url(#paint1_radial_1470_761)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5831 18.3333H28.217C24.3981 18.3333 22.1068 23.3804 20.5792 28.4276C18.7695 34.4071 16.4014 42.4043 23.2524 42.4043H29.0238C30.7485 42.4043 32.2626 41.2639 32.7366 39.6057C33.74 36.0952 35.4985 29.9712 36.8798 25.3093C37.5817 22.9402 38.1664 20.9055 39.0638 19.6385C39.5669 18.9281 40.4053 18.3333 41.5831 18.3333Z",
    fill: "url(#paint2_linear_1470_761)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5831 18.3333H28.217C24.3981 18.3333 22.1068 23.3804 20.5792 28.4276C18.7695 34.4071 16.4014 42.4043 23.2524 42.4043H29.0238C30.7485 42.4043 32.2626 41.2639 32.7366 39.6057C33.74 36.0952 35.4985 29.9712 36.8798 25.3093C37.5817 22.9402 38.1664 20.9055 39.0638 19.6385C39.5669 18.9281 40.4053 18.3333 41.5831 18.3333Z",
    fill: "url(#paint3_linear_1470_761)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.415 51.6667H45.7812C49.6 51.6667 51.8914 46.6187 53.419 41.5707C55.2287 35.5901 57.5968 27.5916 50.7457 27.5916H44.9745C43.2497 27.5916 41.7356 28.7321 41.2617 30.3904C40.2582 33.9015 38.4997 40.0267 37.1184 44.6895C36.4164 47.0591 35.8317 49.094 34.9344 50.3613C34.4313 51.0717 33.5928 51.6667 32.415 51.6667Z",
    fill: "url(#paint4_radial_1470_761)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.415 51.6667H45.7812C49.6 51.6667 51.8914 46.6187 53.419 41.5707C55.2287 35.5901 57.5968 27.5916 50.7457 27.5916H44.9745C43.2497 27.5916 41.7356 28.7321 41.2617 30.3904C40.2582 33.9015 38.4997 40.0267 37.1184 44.6895C36.4164 47.0591 35.8317 49.094 34.9344 50.3613C34.4313 51.0717 33.5928 51.6667 32.415 51.6667Z",
    fill: "url(#paint5_linear_1470_761)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1470_761",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1470_761"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.308333 0 0 0 0 0.308333 0 0 0 0 0.308333 0 0 0 0.34 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_761"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_761",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1470_761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6708 32.0953) rotate(-129.304) scale(14.4194 13.5588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0955758,
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773185,
    stopColor: "#2253CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0736C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1470_761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2679 42.3475) rotate(51.84) scale(13.326 12.9266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633728,
    stopColor: "#FF5F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923392,
    stopColor: "#C02B3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1470_761",
    x1: 27.417,
    y1: 21.2499,
    x2: 29.324,
    y2: 43.3125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156162,
    stopColor: "#0D91E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487484,
    stopColor: "#52B471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652394,
    stopColor: "#98BD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937361,
    stopColor: "#FFC800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1470_761",
    x1: 29.0837,
    y1: 18.3333,
    x2: 30.125,
    y2: 42.4043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246674,
    stopColor: "#0588F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1470_761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.4323 25.2345) rotate(109.274) scale(31.9894 38.3223)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0661714,
    stopColor: "#8C48FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2598A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#FFB152"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1470_761",
    x1: 52.4883,
    y1: 26.1217,
    x2: 52.4746,
    y2: 32.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581535,
    stopColor: "#F8ADFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708063,
    stopColor: "#A86EDD",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoPilot);
export default __webpack_public_path__ + "static/media/co-pilot.f5f8025a49a4ba776d8be794aff7fda4.svg";
export { ForwardRef as ReactComponent };